const toolsGtm = {
    gtmAddToCartSort: function (element, type) {
        if (type == 'full') {
            return {
                'id': element.attr('data-id'),
                'item_list_name': element.attr('data-item-list'),
                'index': element.attr('data-index')
            }
        } else {
            return {
                'item_list_name': element.attr('data-item-list'),
                'index': element.attr('data-index')
            }
        }
    },

    gtmBuyOneClick: function (gtmInfo, orderInfo) {
        if (gtmActive) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: orderInfo.order_id,
                    affiliation: "by_one_click",
                    value: orderInfo.sum,
                    currency: orderInfo.currency,
                    items: [gtmInfo]
                }
            });
        }
    },

    gtmCheckout: function (gtmInfo, orderInfo) {
        if (gtmActive) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: orderInfo.order_id,
                    affiliation: "main",
                    value: orderInfo.sum,
                    currency: orderInfo.currency,
                    items: JSON.parse('[' + gtmInfo + ']'),
                }
            });
        }
    },

    gtmAddToCart: function (gtmInfo, label = 'main') {
        if (gtmActive && Object.keys(gtmInfo).length > 0) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "add_to_cart",
                label: label,
                ecommerce: {
                    items: gtmInfo
                }
            });
        }
    },

    gtmRegister: function () {
        if (gtmActive) {
            dataLayer.push({
                ecommerce: null
            });
            dataLayer.push({
                'event': 'sign_up'
            });
        }
    },

    sendGtm: function (gtmName) {
        if (gtmActive) {
            dataLayer.push({
                ecommerce: null
            });
            dataLayer.push({
                'event': gtmName
            });
        }
    }
};


$(document).ready(function () {
    $(document).on('click', '.js__gtm_link', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var existingGtmInfo = localStorage.getItem('gtm_info');

        if (existingGtmInfo) {
            localStorage.removeItem('gtm_info');
        }

        const link = $(this);
        const gtmItem = toolsGtm.gtmAddToCartSort(link, 'full');

        localStorage.setItem('gtm_info', JSON.stringify(gtmItem));
        window.location.href = link.attr('href');
    });
})


window.toolsGtm = toolsGtm;